import React from "react"
import PropTypes from "prop-types"

import LoaderSection from './LoaderSection'

class StandardButton extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
    this.buttonText = this.buttonText.bind(this)
  }

  buttonText() {
    if(this.props.loading === true) {
      return (
        <div className="whiteLoader" style={{position: 'absolute', marginTop: -40, height: 80, width: 80}}>
        </div>)
    }
    return <p>{this.props.text}</p>
  }

  render() {
    const color = this.props.alert == true ? '#E57373' : '#03A9F4'
    
    return(
      <button
        className={this.props.loading === true ? "whiteLoader" : ""}
        style={{
        backgroundColor: (this.props.primary ? color : 'rgb(255,255,255)'),
        color: (this.props.primary ? '#FFFFFF' : color),
        border: '2px solid #03A9F4',
        borderColor: color,
        borderWidth: 2,
        borderRadius: 30,
        fontSize: (this.props.size === 'small' ? 14 : 15),
        fontWeight: 600,
        paddingTop: 5,
        textAlign: 'center',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: (this.props.size === 'small' ? 20 : 30),
        paddingRight: (this.props.size === 'small' ? 20 : 30),
        maxWidth: (this.props.size === 'large' ? 325 : 'unset'),
        minWidth: (this.props.size === 'large' ? '100%' : 'unset'),
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        minHeight: (this.props.size === 'small' ? 30 : 35)
      }} onClick={() => this.props.onClick()}>
          {!this.props.loading && <p>{this.props.text}</p>}
      </button>
    )
  }
}

export default StandardButton;
